import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "../components/routing/PrivateRoute";
import OfflineBanner from "../components/common/OfflineBanner";
import LoginPage from "../pages/public/LoginPage";
import RegisterPage from "../pages/public/RegisterPage";
import AppLayout from "../components/layout/AppLayout";
import DashboardPage from "../pages/app/DashboardPage";
import TransfersListPage from "../pages/app/TransfersListPage";
import TransferFormPage from "../pages/app/TransferFormPage";
import SeriesListPage from "../pages/app/SeriesListPage";
import SeriesFormPage from "../pages/app/SeriesFormPage";
import AnalyticsPage from "../pages/app/AnalyticsPage";
import LocationsPage from "../pages/app/LocationsPage";
import ProvidersPage from "../pages/app/ProvidersPage";
import ClientsPage from "../pages/app/ClientsPage";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <OfflineBanner />
      <Routes>
        <Route path="/" element={<Navigate to="/app/dashboard" replace />} />

        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Private */}
        <Route element={<PrivateRoute />}>
          <Route path="/app" element={<AppLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="transfers" element={<TransfersListPage />} />
            <Route path="transfers/new" element={<TransferFormPage />} />
            <Route path="transfers/:id/edit" element={<TransferFormPage  />} />

            <Route path="series" element={<SeriesListPage />} />
            <Route path="series/new" element={<SeriesFormPage  />} />
            <Route path="series/:id/edit" element={<SeriesFormPage />} />

            <Route path="clients" element={<ClientsPage />} />
            <Route path="providers" element={<ProvidersPage />} />
            <Route path="locations" element={<LocationsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
